import { calculateSubunitToUnit } from "utils/helpers/currency";
import {
  addValues,
  multiplyValues,
  subtractValues,
  divideValues,
} from "utils/helpers/math";
import { absValue } from "utils/helpers";

export const calculateTotalAndGst = (data, gst) => {
  let total = subtractValues([
    addValues([data.gross, data.retention_dlrr, data.retention_pcrr]),
    data.retention,
  ]);
  let gstTotal = multiplyValues([total, calculateSubunitToUnit(gst)]);
  return [total, gstTotal];
};

export const tableValueProvisional = (isProvisional, values, max) => {
  const { formattedValue, floatValue } = values;

  return isProvisional
    ? true
    : formattedValue === "" || absValue(floatValue) <= max;
};

export const tableValueIsAllowed = (values, total, isProvisional) => {
  const max = absValue(divideValues([total || 0, 100]));
  return tableValueProvisional(isProvisional, values, max);
};
